import React from 'react'
import {Box, ListItem, Typography, withStyles} from '@material-ui/core';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import moment from 'moment';
import DateFormats from "constants/DateFormats";

const style = theme => ({
    root: {},
    grid: {
        '&>*:first-child': {
            flexGrow: 1,
            marginRight: theme.spacing(2),
        },
        '&>*:nth-child(2)': {
            width: 130
        }
    },
})

function ListElement({
     classes,
     item,
    trPrefix = ""

                     }) {

    const {owner, history} = item
    const {operationType, operationDatetime, role} = history
    const {firstName, lastName, member} = owner

    const boldDouble = (firstName, lastName) => <Box component='span' fontWeight='fontWeightBold'>{`${firstName} ${lastName}`}</Box>
    const bold = (t) => <Box component='span' fontWeight='fontWeightBold'>{t}</Box>

    const textVariant = {
        DELETE: (<>
            {Tr('history_popup_del_1')}{' '}
            {bold(Tr('history_popup_del_2'))}{' '}
            {Tr('history_popup_del_3')}
        </>),
        ADD: (<>
            {Tr('history_popup_add_1')}{' '}
            {bold(Tr('history_popup_add_2'))}{' '}
            {Tr('history_popup_add_3')}{' '}
            {Tr('history_popup_add_4')}{' '}
            {bold(Tr(trPrefix + role.toUpperCase()))}
        </>),
        MODIFY: (<>
            {Tr('history_popup_role_0')}{' '}
            {bold(Tr(trPrefix + role.toUpperCase()))}
        </>)
    }

    return (
        <ListItem>
            <GridBlock
                wrap='nowrap'
                className={classes.grid}
            >
                <Typography variant='body1'>
                    {member ? boldDouble(member.firstName, member.lastName) : boldDouble(firstName, lastName)}
                    {' '}
                    {textVariant[operationType.trim()]}
                </Typography>
                <Typography
                    variant='body1'
                >
                    {moment(operationDatetime).format(DateFormats.DATE_FORMAT)}
                </Typography>
            </GridBlock>
        </ListItem>
    )
}

export default withStyles(style)(ListElement);